import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ReactQueryKey } from "../../../../../../../types";
import { getBookingProducts } from "../../../../../../../api/services";
import { FormAutocomplete } from "../../../../../../../components/fields";
import useFormTenantsDealers from "../form-tenants-dealers-hook/useFormTenantsDealers";

/**
 * Filter Form component of product
 */
const FormAutocompleteProduct = () => {
    const { t } = useTranslation('booking');
    const { tenants, dealers } = useFormTenantsDealers();

    const productsQuery = useQuery({
        queryKey: [ReactQueryKey.BookingProducts, { tenants, dealers }],
        queryFn: () => getBookingProducts({ tenants, dealers }),
    });

    return (
        <FormAutocomplete<any>
            name="products"
            label={t('label.products')}
            options={productsQuery.data || []}
            loading={productsQuery.isLoading}
            isOptionEqualToValue={(option, value) => option.code === value.code}
            getOptionLabel={(option) => (option.code + ' - ' + option.label)}
            multiple
        />
    );

}

export default FormAutocompleteProduct;
